import React from "react";
import TooltipInfo from "../tooltip-info";

const FormInput = (props) => {
  const {
    label,
    showCount,
    inputType = "textField",
    onChange,
    labelInfo,
    ...rest
  } = props;

  const renderLabel = React.useCallback(() => {
    if (!label) return null;
    return (
      <div className="booking-form__label">
        <label className="form-label user-select-none d-flex align-items-center">
          {label}{" "}
          {labelInfo && (
            <TooltipInfo title={labelInfo} />
          )}
        </label>
      </div>
    );
  }, [label]);

  const handleChange = (e) => {
    const { value } = e.target;
    onChange?.(value);
  };

  const renderFormInput = () => {
    if (inputType === "textField") {
      return (
        <input className="form-control" onChange={handleChange} {...rest} />
      );
    }
    if (inputType === "textarea") {
      return (
        <textarea className="form-control" onChange={handleChange} {...rest} />
      );
    }
  };

  return (
    <div className="booking-form__row">
      {renderLabel()}
      <div className="booking-form__control">
        <div className="form-switch">
          <div className="common-view__input-with-count">
            {renderFormInput()}
            {showCount && (
              <span className="common-view__count">
                {rest?.value?.length || 0}/{rest.maxLength}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FormInput);
